import { buildFormData } from "./payload.helper";

const ALLOWED_FIELDS = [
  "patient_id",
  "unit_id",
  "physician_id",
  "hospital_name",
  "referred_location",
  "first_aid_given",
  "status",
  "cause_of_referral",
];

const pickFields = (data) =>
  ALLOWED_FIELDS.reduce((acc, key) => {
    if (data[key] !== undefined) {
      acc[key] = data[key];
    }
    return acc;
  }, {});

const patientReferralsHelper = {
  forCreate: (data) => buildFormData(pickFields(data)),

  forUpdate: (id, data) => ({
    id,
    body: buildFormData(pickFields(data)),
  }),
};
export default patientReferralsHelper;